<template>
  <div>
    <h1>Felhasználók</h1>
    <div class="buttons-holder">
      <a-button type="primary" icon="plus" v-on:click="openModalFormNew">Új felhasználó felvétele</a-button>
    </div>
    <a-modal
      :visible="userFormOpen"
      :title="modalTitle"
      onOk="handleOk"
      v-on:cancel="handleFormCancel"
      centered
      :maskClosable="false"
      :closable="false"
      :afterClose="resetModalData"
    >
      <a-spin :spinning="formSubmitLoading">
        <UserFormComponent :newUser="newUser" :formValues="userForm" v-on:formSubmitted="handleUserFormSubmit" />
      </a-spin>
      <template slot="footer">
        <a-button v-on:click="handleFormCancel">Mégse</a-button>
      </template>
    </a-modal>
    <div class="existing-users">
      <UsersTableComponent 
        :userData="userData" 
        :loading="usersLoading" 
        v-on:editUser="handleEditUser"
        v-on:deleteUser="handleDelete"
        v-on:switchActive="handleSwitchActive"
      />
    </div>
  </div>
</template>

<script>
import UserFormComponent from "./UserFormComponent.vue";
import UsersTableComponent from './UsersTableComponent.vue';
import { createUser, getUsers, modifyUser, deleteUser } from "@/http/api.js";

const userFormDefaults = {
  email: "",
  password: "",
  phone: "",
  roles: []
};

export default {
  components: {
    UserFormComponent,
    UsersTableComponent
  },

  created() {
    this.requestUserData();
  },

  data() {
    return {
      userFormOpen: false,
      newUser: true,
      userForm: { ...userFormDefaults },
      formType: "",
      currentUser: null,
      formSubmitLoading: false,
      userData: [],
      usersLoading: false
    };
  },

  computed: {
    modalTitle() {
      switch (this.formType) {
        case "create":
          return "Új Felhasználó felvétele";
          break;
        case "modify":
          return "Felhasználó Módosítása";
          break;
        default:
          return "Felhasználó Űrlap";
      }
    }
  },

  methods: {
    requestUserData() {
      this.usersLoading = true;
      getUsers()
        .then(res => {
          console.log("USERSDATA", res);
          this.userData = res.data.data;
          this.usersLoading = false;
        })
        .catch(err => {
          console.log("USERSERR", err);
          this.usersLoading = false;
        });
    },
    openModalFormModify() {
      const userFormData = {
        email: this.currentUser.email,
        password: null,
        phone: this.currentUser.phone,
        roles: [...this.currentUser.roles]
      }
      this.formType = "modify";
      this.userForm = { ...userFormData };
      this.userFormOpen = true;
    },
    openModalFormNew() {
      this.formType = "create";
      this.userForm = { ...userFormDefaults };
      this.userFormOpen = true;
    },
    handleFormSave(e) {},
    handleFormCancel(e) {
      this.userFormOpen = false;
    },
    resetModalData() {
      this.userForm = { ...userFormDefaults };
      this.formType = "";
      this.currentUser = null;
      this.newUser = true;
      this.formSubmitLoading = false;
    },
    handleUserFormSubmit(formValues) {
      console.log("form submit", formValues);
      this.formSubmitLoading = true;
      const values = {};
      for (const key in formValues) {
        if (typeof formValues[key] === 'boolean' || formValues[key]) {
          values[key] = formValues[key]
        }
      };
      console.log('VALSWITHVALS', values);
      switch (this.formType) {
        case "create":
          createUser(values)
          .then(res => {
            console.log("USERCREATERES", res);
            this.formSubmitLoading = false;
            this.handleFormCancel();
            this.requestUserData();
          })
          .catch(err => {
            console.log("USERCREATE_ERR", err);
            this.formSubmitLoading = false;
            this.handleFormCancel();
          });
          break;
        case "modify":
          modifyUser(values, this.currentUser.uuid)
          .then(res => {
            console.log("USERMODIFYRES", res);
            this.formSubmitLoading = false;
            this.handleFormCancel();
            this.requestUserData();
          })
          .catch(err => {
            console.log("USERMODIFY_ERR", err);
            this.formSubmitLoading = false;
            this.handleFormCancel();
          });
          break;
        default:
          return
      }

      
    },

    handleEditUser(userData) {
      console.log('EDIT', userData);
      this.currentUser = {...userData};
      this.newUser = false;
      this.openModalFormModify();
    },
    handleDelete(userData) {
      deleteUser({}, userData.uuid)
      .then(res => {
        console.log('USER_DELETED', res);
        this.requestUserData();
      })
      .catch(err => {
        console.log('USER_DELETE_ERR', err);
      }) 
    },
    handleSwitchActive(switchActiveData) {
      const currentState = switchActiveData.activeState;
      const userData = switchActiveData.record;
      console.log('ST', currentState);
      console.log('DATA', userData);
      const nextState = !currentState;

      const formValues = {
        isActive: nextState,
        isNonLocked: nextState
      };
      this.currentUser = {...userData};
      this.newUser = false;
      this.formType = 'modify';
      this.handleUserFormSubmit(formValues);
    }
  }
};
</script>

<style lang="scss" scoped>
  .buttons-holder {
    margin-bottom: 15px;
  }
</style>